exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Gleam-ec9165f0{display:inline-block;height:1.5em;line-height:1.5em;border-radius:1.5em;background:currentColor;padding:0 0.5em;text-align:center;margin:0 4px}.content-892da30f{color:#FFF;font-weight:bold}\n", ""]);

// Exports
exports.locals = {
	"Gleam": "Gleam-ec9165f0",
	"content": "content-892da30f"
};